import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { UserModel } from "@/app/entities/user.model";

export interface UserApiResponse {
  totalPages: number;
  totalElements: number;
  first: boolean;
  last: boolean;
  pageable: Pageable;
  size: number;
  content: UserModel[];
  number: number;
  sort: any;
  numberOfElements: number;
  empty: boolean;
}

export interface UserAdresse {
  pays: string;
  cp: string;
  ville: string;
  intituleRue: string;
  numeroRue: number;
  adresseComplete: string;
}

interface Pageable {
  pageNumber: number;
  pageSize: number;
  sort: any;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

interface UserStoreType {
  users: UserApiResponse;
  loading: boolean;
  saving: boolean;
  setUsers: (users: UserApiResponse) => void;
  addUser: (user: UserModel) => void;
  updateUser: (matricule: string, user: UserModel) => void;
  deleteUser: (matricule: string) => void;
  setLoading: (loading: boolean) => void;
  setSaving: (saving: boolean) => void;
}

export const useUserStore = create<UserStoreType>()(
  persist(
    (set, get) => ({
      users: {
        totalPages: 0,
        totalElements: 0,
        first: false,
        last: false,
        pageable: {
          pageNumber: 0,
          pageSize: 0,
          sort: {},
          offset: 0,
          paged: false,
          unpaged: false,
        },
        size: 0,
        content: [],
        number: 0,
        sort: {},
        numberOfElements: 0,
        empty: false,
      },
      loading: false,
      saving: false,
      setUsers: (users: UserApiResponse) =>
        set((state) => ({ ...state, users: { ...state.users, ...users } })),
      addUser: (user: UserModel) =>
        set((state) => ({
          ...state,
          users: { ...state.users, content: [...state.users.content, user] },
        })),
      updateUser: (matricule: string, user: UserModel) =>
        set((state) => ({
          ...state,
          users: {
            ...state.users,
            content: state.users.content.map((u) =>
              u.matricule === matricule ? user : u
            ),
          },
        })),
      deleteUser: (matricule: string) =>
        set((state) => ({
          ...state,
          users: {
            ...state.users,
            content: state.users.content.filter(
              (u) => u.matricule !== matricule
            ),
          },
        })),
      setLoading: (loading: boolean) => set((state) => ({ ...state, loading })),
      setSaving: (saving: boolean) => set((state) => ({ ...state, saving })),
    }),
    {
      name: "use-user-store", // Key for localStorage
      storage: createJSONStorage(() => localStorage), // Default storage
    }
  )
);
